import { CARD_SIZE, FREE_INDEX, modalityDefinition, type Modality } from '@bingo/shared';
import { useEffect, useState } from 'react';

/**
 * Mini-cartela da faixa "Valendo".
 *
 * Anima o padrão da modalidade, um frame a cada 900ms, exatamente como o
 * protótipo. Modalidade de um frame só (cantos, cartela cheia) fica estática.
 */
export function MiniCard({ modality }: { modality: Modality }) {
  const definition = modalityDefinition(modality);
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    setFrame(0);
    if (definition.frames.length <= 1) return;

    const timer = window.setInterval(
      () => setFrame((current) => (current + 1) % definition.frames.length),
      900,
    );

    return () => window.clearInterval(timer);
  }, [definition]);

  const pattern = new Set(definition.frames[frame] ?? definition.frames[0] ?? []);

  return (
    <div className="mini" aria-hidden="true">
      {Array.from({ length: CARD_SIZE }, (_, index) => (
        <i key={index} className={index === FREE_INDEX ? 'free' : pattern.has(index) ? 'on' : ''} />
      ))}
    </div>
  );
}

/** Versão estática, para o seletor de modalidade no /controle. */
export function MiniCardStatic({ pattern }: { pattern: readonly number[] }) {
  const marked = new Set(pattern);

  return (
    <span className="mini" aria-hidden="true">
      {Array.from({ length: CARD_SIZE }, (_, index) => (
        <i key={index} className={index === FREE_INDEX ? 'free' : marked.has(index) ? 'on' : ''} />
      ))}
    </span>
  );
}
